module.exports = __webpack_public_path__ + "static/logo-e58407d2a1472db5e7790435b2a28c4f.png";